export default "__VITE_ASSET__BKDXa7aY__"